export const GET_GROUP_ACTIVITIES_START =
  'GET_GROUP_ACTIVITIES_START';
export const GET_GROUP_ACTIVITIES_SUCCESS =
  'GET_GROUP_ACTIVITIES_SUCCESS';
export const GET_GROUP_ACTIVITIES_ERROR =
  'GET_GROUP_ACTIVITIES_ERROR';
